import axios from 'Services/axiosInterceptor';
import { externalBaseUrl } from '../../../../configs/constants';

export const editProfile = (payload) => {
  return axios.post(`${externalBaseUrl}/users/update-profile`, payload);
};